import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { v4 as uuidv4 } from 'uuid';

import Iconify from '../../../../components/Iconify';
import { getRandomColor } from '../../../../services/functions';
import { useAccomodationDiagram } from '../AccomodationDiagramContext';
import { ColorPicker } from '../../../../components/ColorPicker';

export const RelatedOrdersMenuDialog = props => {
  const { open, setOpen, order, orders, setOrders, houseOrders, setHouseOrders, nodes } = props;
  const { updateNodesF, handleRelatedGroups } = useAccomodationDiagram();
  const [selectedColor, setSelectedColor] = React.useState(getRandomColor()); // Domyślny kolor

  const handleColorChange = color => {
    const newColor = color.hex; // Nowy kolor z inputu
    setSelectedColor(newColor); // Ustaw nowy kolor
  };

  const options = houseOrders ? houseOrders.filter(o => {
    if (!order.relatedGroup) {
      return o.id !== order.id;
    }

    return true;
  }).filter(o => !o.relatedGroup)
    .map(o => `${o.participant_name} - ${o.identifier}`) : orders.filter(o => {
    if (!order.relatedGroup && o.participant_gender == order.participant_gender) {
      return o.id !== order.id;
    }

    return true;
  }).filter(o => !o.relatedGroup && o.participant_gender == order.participant_gender)
    .map(o => `${o.participant_name} - ${o.identifier}`);

  const [selectedOrders, setSelectedOrders] = React.useState([]);
  const [inputValue, setInputValue] = React.useState('');

  const onSubmit = () => {
    const identifiers = [order.identifier];
    for (const o of selectedOrders) {
      const identifier = o.split(' - ');
      identifiers.push(identifier.at(-1));
    }
    createRelatedGroup(identifiers);
  };

  const createRelatedGroup = identifiers => {
    const newGroup = {
      id: uuidv4(),
      color: selectedColor
    };
    if (houseOrders) {
      // Strategia przypisywania do grupy z poziomu diagramu
      const newNodes = nodes.map(n => {
        if (identifiers.includes(n.data?.order?.identifier)) {
          return { ...n, data: { ...n.data, order: { ...n.data.order, relatedGroup: newGroup } } };
        }

        return n;
      });
      updateNodesF(newNodes);
      handleRelatedGroups(null, newNodes);
    } else {
      // Strategia przypisywania do grupy z poziomu listy zamówień
      const newOrders = orders;
      newOrders.map(o => {
        if (identifiers.includes(o.identifier)) {
          o.relatedGroup = newGroup;
        }
      });
      // const groupedOrders = groupOrders(newOrders);
      setOrders(newOrders);
      handleRelatedGroups(newOrders);
    }
    setOpen(false);
    setHouseOrders(null);
  };

  const handleClose = () => {
    setOpen(false);
    setHouseOrders(null);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
    >
      <DialogTitle id="add-new-house-dialog">Powiąż zamówienia</DialogTitle>
      <DialogContent>
        <Stack direction="column" spacing={3}>
          <Stack direction="row" alignItems="center" justifyContent="right" spacing={1} mt={2}>
            <Typography variant="subtitle2" flex="1 1 30%">Lista dostępnych zamówień</Typography>
            <Autocomplete
              multiple
              value={selectedOrders}
              onChange={(event, newValue) => {
                setSelectedOrders(newValue);
              }}
              inputValue={inputValue}
              onInputChange={(event, newInputValue) => {
                setInputValue(newInputValue);
              }}
              id="controllable-states-demo"
              options={options}
              sx={{ width: 400 }}
              renderInput={params => <TextField {...params} label="Wybierz zamówienia" />}
            />
          </Stack>
          <Stack direction="row" alignItems="center" justifyContent="left" spacing={1} mt={2}>
            <Typography variant="subtitle2" flex="1 1 30%">Wybierz kolor grupy</Typography>
            <ColorPicker color={selectedColor} handleColorChange={handleColorChange} width="70%" />
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack>
          <Button
            fullWidth
            variant="contained"
            endIcon={<Iconify icon={'eva:save-fill'} />}
            onClick={onSubmit}
          >
            Zapisz zmiany
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};
